import { useEffect, useState } from "react";
import { formattedSlotData } from "../../pages/AquaZone/aquahelper";
import AquaZoneHeader from "./AquaZoneHeader";
import { res, timeArray } from "../../tempConst";
import DatePickerInput from "../Datepicker";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import SlotLayout from "./SlotLayout";
import Modal from "../Modal";
import styled from "styled-components";
import Textarea from "../Textarea";
import Selectfield from "../Merchant/Selectfield";
import DateBlocked from "./DateBlocked";
import BlockSlotModal from "./BlockSlotModal";
import BlockDateModal from "./BlockDateModal";
import SlotTabHeader from "./SlotTabHeader";
import {
  blockSlot,
  enableSlot,
  getAquaSlotDetails,
} from "../../services/aquaServices";
import { getSettings } from "../../services/settingsService";
import { getFormattedDate } from "../getFormattedDate";
import ConfirmModal from "./ConfirmModal";
import { useLoadContext } from "../../contexts/LoadContext";
import { toast } from "react-toastify";

const AquaZoneSlotTabContent = () => {
  const [data, setData] = useState({});
  const [masterSlot, setMasterSlot] = useState({});
  const [masterProdInfo, setMasterProdInfo] = useState({});
  const [outletInfo, setOutletInfo] = useState({});
  const [productInfo, setProductInfo] = useState({});
  const [calendarDate, setCalendarDate] = useState<Date | null | any>(
    new Date()
  );
  const [toDate, setToDate] = useState<Date | null | any>();
  const [isBlockDateModalOpen, setBlockDateModal] = useState(false);
  const [isBlockSlotModalOpen, setBlockSlotModal] = useState(false);
  const [isBlockedDay, setBlockedDay] = useState("");
  const [confirm, setConfirm] = useState({ type: "", open: false });
  const [blockDateData, setBlockDateData] = useState({
    fromDate: "",
    comment: "",
  });
  const [blockSlotData, setBlockSlotData] = useState({
    product: "",
    slot: "",
    fromDate: "",
    comment: "",
  });
  let today = new Date();
  const [productsList, setProductsList] = useState([]);
  const [timeSlot, setTimeSlot] = useState([]);
  const { setLoader } = useLoadContext();

  useEffect(() => {
    fetchData(today);
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    let settings = await getSettings("cms");
  };

  const fetchData = async (date: any) => {
    setLoader(true);
    try {
      let formattedDate = getFormattedDate(date, "YYYY-MM-DD");
      let slotResponse = await getAquaSlotDetails(formattedDate);
      let data = formattedSlotData(
        slotResponse?.data?.data?.productInfo,
        slotResponse?.data?.data?.calenderData,
        slotResponse?.data?.data?.masterSlot
      );
      setMasterProdInfo(slotResponse?.data?.data?.productInfo);
      setOutletInfo(slotResponse?.data?.data?.outletInfo);
      if (slotResponse?.data?.data?.calenderData.length > 0) {
        let blockedDaySlot = slotResponse?.data?.data?.calenderData.filter(
          (slot: any) =>
            slot.blockedFor === "blockedDay" && slot.status === "active"
        )[0];
        setBlockedDay(blockedDaySlot?._id || "");
      } else {
        setBlockedDay("");
      }

      setData(data);
      setMasterSlot(slotResponse?.data?.data?.masterSlot);

      let prodObj = [];
      slotResponse?.data?.data?.productInfo.map((item: any) => {
        prodObj.push({ label: item.name, value: item._id });
      });
      prodObj.unshift({
        value: "",
        label: "Select Product",
      });
      // @ts-ignore
      setProductsList(prodObj);

      let slotObj = slotResponse?.data?.data?.masterSlot.map((slot: string) => {
        return {
          label: slot,
          value: slot,
        };
      });
      slotObj.unshift({
        value: "",
        label: "Select Slot",
      });
      setTimeSlot(slotObj);

      let categoryArray = {};
      slotResponse?.data?.data?.productInfo.map(
        // @ts-ignore
        (info) => (categoryArray[info._id] = info.name)
      );
      setProductInfo(categoryArray);
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setLoader(false);
    }
  };

  const handleBlockDate = async () => {
    try {
      let res = await blockSlot({
        date: getFormattedDate(blockDateData?.fromDate, "YYYY-MM-DD"),
        type: "day",
        reason: blockDateData?.comment,
        confirm: "",
      });
      if (
        res?.data?.data?.bookedInfo &&
        res?.data?.data?.bookedInfo?.length > 0
      ) {
        setConfirm({ open: true, type: "date" });
      } else {
        setBlockDateModal(false);
        setBlockDateData({
          fromDate: "",
          comment: "",
        });
        fetchData(getFormattedDate(blockDateData?.fromDate, "YYYY-MM-DD"));
        setCalendarDate(blockDateData?.fromDate);
      }
    } catch (err) {
      // @ts-ignore
      toast.error(err?.message);
    }
  };

  const handleBlockSlot = async () => {
    try {
      let res = await blockSlot({
        date: getFormattedDate(blockSlotData?.fromDate, "YYYY-MM-DD"),
        type: "slot",
        reason: blockSlotData?.comment,
        productId: blockSlotData.product,
        slot: blockSlotData.slot,
        unit: 1,
      });
      // if (
      //   res?.data?.data?.bookedInfo &&
      //   res?.data?.data?.bookedInfo?.length > 0
      // ) {
      //   setConfirm({ open: true, type: "slot" });
      // } else {
        setBlockSlotModal(false);
        setBlockSlotData({
          product: "",
          slot: "",
          fromDate: "",
          comment: "",
        });
        fetchData(getFormattedDate(blockSlotData?.fromDate, "YYYY-MM-DD"));
        setCalendarDate(blockSlotData?.fromDate);
      // }
    } catch (err) {
      // @ts-ignore
      toast.error(err?.message);
    }
  };

  const handleBlockDateDataChange = (e: any) => {
    setBlockDateData({ ...blockDateData, [e.target.name]: e.target.value });
  };
  const handleBlockSlotDataChange = (e: any) => {
    setBlockSlotData({ ...blockSlotData, [e.target.name]: e.target.value });
  };

  const handleCalendarDateChange = (e: any) => {
    setCalendarDate(e);
    fetchData(e);
  };

  const handleConfirmClose = () => {
    setConfirm({
      open: false,
      type: "",
    });
  };

  const handleConfirm = async () => {
    try {
      if (confirm.type === "date") {
        let res = await blockSlot({
          date: getFormattedDate(blockDateData?.fromDate, "YYYY-MM-DD"),
          type: "day",
          reason: blockDateData?.comment,
          confirm: "yes",
        });
      } else {
        let res = await blockSlot({
          date: getFormattedDate(blockSlotData?.fromDate, "YYYY-MM-DD"),
          type: "slot",
          reason: blockSlotData?.comment,
          productId: blockSlotData.product,
          slot: blockSlotData.slot,
          unit: 1,
          confirm: "yes",
        });
      }
      setConfirm({
        type: "",
        open: false,
      });
      fetchData(
        confirm.type === "date"
          ? getFormattedDate(blockDateData?.fromDate, "YYYY-MM-DD")
          : getFormattedDate(blockSlotData?.fromDate, "YYYY-MM-DD")
      );
      setCalendarDate(
        confirm.type === "date"
          ? blockDateData?.fromDate
          : blockSlotData?.fromDate
      );

      setBlockDateModal(false);
      setBlockSlotModal(false);
      setBlockSlotData({
        product: "",
        slot: "",
        fromDate: "",
        comment: "",
      });
      setBlockDateData({
        fromDate: "",
        comment: "",
      });
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  const handleUnBlockDate = async () => {
    try {
      let res = await enableSlot({
        activityId: isBlockedDay,
        reason: "unblock",
      });
      fetchData(calendarDate);
    } catch (err: any) {
      toast.error(err.message);
    }
  };

  const handleRefresh = async () => {
    fetchData(calendarDate);
  };

  return (
    <>
      <SlotTabHeader
        calendarDate={calendarDate}
        today={today}
        onBlockDateSelect={() => setBlockDateModal(true)}
        onBlockSlotSelect={() => setBlockSlotModal(true)}
        onCalendarDateChange={handleCalendarDateChange}
        outletInfo={outletInfo}
        onRefresh={() => handleRefresh()}
      />
      {isBlockedDay ? (
        <DateBlocked date={calendarDate} onBlock={handleUnBlockDate} />
      ) : (
        <SlotLayout
          slotData={data}
          timeArray={masterSlot}
          productInfo={productInfo}
          masterProdInfo={masterProdInfo}
        />
      )}
      {isBlockDateModalOpen && (
        <BlockDateModal
          today={new Date()}
          onBlockDateClose={() => {
            setBlockDateModal(false);
            setBlockDateData({
              fromDate: "",
              comment: "",
            });
          }}
          onBlockDate={handleBlockDate}
          data={blockDateData}
          onDateDataChange={handleBlockDateDataChange}
        />
      )}
      {isBlockSlotModalOpen && (
        <BlockSlotModal
          products={productsList}
          timeSlot={timeSlot}
          today={new Date()}
          onBlockSlotClose={() => {
            setBlockSlotModal(false);
            setBlockSlotData({
              product: "",
              slot: "",
              fromDate: "",
              comment: "",
            });
          }}
          onBlockSlot={handleBlockSlot}
          data={blockSlotData}
          onSlotDataChange={handleBlockSlotDataChange}
        />
      )}
      {/* @ts-ignore */}
      {confirm.open && (
        <ConfirmModal
          onConfirmClose={handleConfirmClose}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
};

export default AquaZoneSlotTabContent;
